import React from "react";

export interface ErrorMessageProps {
  message: string;
}
export default function ErrorMessage({ message }: ErrorMessageProps) {
  return <div>{message}</div>;
}
